import React, { ChangeEvent, FunctionComponent, RefObject } from 'react';
import type { Props as ComponentProps } from './types';

type Props = ComponentProps & {
  focusRef: RefObject<HTMLInputElement>;
  onCompanyNameChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleIndustryChange: (industryId: string) => void;
};

export const Presentation: FunctionComponent<Props> = (props) => {
  const searchModalClassName = `search-modal ${props.isOpen ? 'open' : ''} ${!props.showIndustryFilter ? ' is-height' : ''}`;

  return (
    <>
      <div className={searchModalClassName}>
        <div className="search-modal__wrapper">
          <div className="search-modal__header">
            <button className="search-modal__close" onClick={props.onClose}>
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0.735395 12L0 11.2646L5.26461 6L0 0.735394L0.735395 0L6 5.26461L11.2646 0L12 0.735394L6.7354 6L12 11.2646L11.2646 12L6 6.73539L0.735395 12Z"
                  fill="#19190F"
                />
              </svg>
            </button>
            <h2 className="search-modal__title">検索</h2>
          </div>
          <div className="search-modal__content">
            <div className="search-modal__section">
              <h3 className="search-modal__section--title">会社名で検索</h3>
              <input
                inputMode="search"
                type="text"
                ref={props.focusRef}
                value={props.companyName}
                onChange={props.onCompanyNameChange}
                placeholder="会社名を入力してください"
                className="search-modal__input"
              />
            </div>
            {props.showIndustryFilter && (
              <div className="search-modal__section">
                <h3 className="search-modal__section--title">業種で絞り込む</h3>
                <div className="search-modal__industries">
                  {props.industries.map((industry) => (
                    <label
                      key={industry.id}
                      className={`search-modal__industry--button ${props.selectedIndustries.includes(industry.id.toString()) ? 'search-modal__industry--button--checked' : ''}`}
                    >
                      <input
                        type="checkbox"
                        value={industry.id}
                        checked={props.selectedIndustries.includes(industry.id.toString())}
                        onChange={() => props.handleIndustryChange(industry.id.toString())} // string[]で受け取るように調整
                        className="search-modal__industry--checkbox"
                      />
                      <span className="search-modal__industry--name">{industry.name}</span>
                      {props.selectedIndustries.includes(industry.id.toString()) && (
                        <span className="search-modal__industry--check">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="10"
                            viewBox="0 0 14 10"
                            fill="none"
                          >
                            <path
                              d="M4.88542 9.89714L0.21875 5.23047L1.11458 4.33464L4.88542 8.10547L12.8854 0.105469L13.7812 1.0013L4.88542 9.89714Z"
                              fill="#19190F"
                            />
                          </svg>
                        </span>
                      )}
                    </label>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div className="search-modal__footer">
            <div className="btnCover">
              <button onClick={props.onClear} className="btn clear">
                すべてクリア
              </button>
            </div>
            <div className="btnCover">
              <button onClick={props.onSearch} className="btn" disabled={props.loading}>
                {props.filteredCompaniesCount}件を検索
              </button>
            </div>
          </div>
        </div>
      </div>
      <div onClick={props.onClose} className={`search-modal__overlay ${props.isOpen ? 'open' : ''}`}></div>
    </>
  );
};
